import { filter, split, reduce, find, sortBy, findIndex  } from 'lodash';
import { IFarm, IProduct, ISilo, IPedido, IFeedPlan, IFeed, IFestivo, IIPedido, IIFeedPlan, IIFarm } from './types';
import { adalApiFetch } from './adalConfig';

const fetchAPI = (
    url: string,
    method: string,
    parseJSON = false,
    body: any = undefined,
    headers = true
): Promise<any> => {
    return adalApiFetch(fetch, url, {
        method: method,
        mode: 'cors',
        redirect: 'follow',
        body: body ? JSON.stringify(body) : body,
        headers: headers
            ? new Headers({
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json; charset=utf-8',
            })
            : undefined
    }).then((response: any) => {
        if (response.ok) {
            if (parseJSON) {
                return response.json();
            }
        } else if (!parseJSON) {
            throw new Error(`Error ${response.status}`);
        } else {
            try {
                return response.json().then((data: any) => {
                    console.log('Error!');
                    return Promise.reject(new Error(data.message));
                });
            } catch (err) {
                throw new Error(`Error ${response.status}`);
            }
        }
        return response;
    });
}

const searchFarms = (inputData:Array<IIFarm>, value: string) => {
    let lowerCaseValue = value.toLowerCase();
    let arrayValues : Array<string> = splitData(lowerCaseValue);
    let Farms : Array<IIFarm> = inputData;

    arrayValues.forEach(element => {
        Farms = filter(Farms,function(item){
        return item['name'].toLowerCase().indexOf(element)!==-1 || String(item['id']).toLowerCase().indexOf(element)!==-1;
        });
    });

    return Farms;
}

const searchProducts = (inputData:Array<IProduct>, value: string) => {
    let lowerCaseValue = value.toLowerCase();
    let arrayValues : Array<string> = splitData(lowerCaseValue);
    let Products : Array<IProduct> = inputData;

    arrayValues.forEach(element => {
        Products = filter(Products,function(item){
        return item['itemName'].toLowerCase().indexOf(element)!==-1||
        String(item['typeDsc']).toLowerCase().indexOf(element)!==-1;
        });
    });
    return Products;
}

const searchPedidos = (inputData:Array<IIPedido>, value: string) => {
    let lowerCaseValue = value.toLowerCase();
    let arrayValues : Array<string> = splitData(lowerCaseValue);
    let Pedidos : Array<IIPedido> = inputData;
    arrayValues.forEach(element => {
        Pedidos = filter(Pedidos,function(item){
            return item['farm']['name'].toLowerCase().indexOf(element)!==-1 || 
                item['idPedido'].toLowerCase().indexOf(element)!==-1 
                //|| getStatusDescriptionColor(item['status'])[0].toLowerCase().indexOf(element)!==-1;
                || item['statusDsc'].toLowerCase().indexOf(element)!==-1;
        });
    });

    return Pedidos;
}

const splitData = (input:string) => {
    return split(input,' ');
}

const GetFormattedDate = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime .getFullYear();
    return year + "-" + (month < 10?'0'+month:month) + "-" + (day < 10?'0'+day:day)+"T00:00:00.000Z";
}

const GetDate = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime .getFullYear();
    return year + "-" + (month < 10?'0'+month:month) + "-" + (day < 10?'0'+day:day);
}

const getNextOrden = (input:Array<ISilo>)=>{
    let orderedInput = sortBy(input, [function(o) { return o.order; }]);
    for (let i = 0; i < orderedInput.length; i++) {
       
        if (orderedInput[i].order !== (i + 1)) 
          return (i+1);
    }
    return orderedInput.length + 1; 
}

const getQuantitySilo = (capacidadSilo:number, quantity: number, cantidadAcum:number) => {
    if(!(cantidadAcum < quantity))
        return 0;
    
    let result = capacidadSilo - (quantity-cantidadAcum);
    if(result < 0){
        return capacidadSilo
    }
    return (quantity-cantidadAcum);
}

const getAcumuladoPienso = (input:Array<ISilo>) => {
    let cantidadAcum = reduce(
        input,
        function(accumulated, e){
            return accumulated + (e.quantity!==undefined?e.quantity:0);
        },
        0
    );

    return cantidadAcum;
}

const verifyDateTimeLimit=(inputData:any, maxHour: number, beforeLimitTime:number, festivos: Array<IFestivo>)=>{

    const isFestivo = (inputDay: Date) => { // No deja poner ni Sábado ni Domingo ni los días específicos como festivos
        if(inputDay.getDay() !== 0 && inputDay.getDay() !== 6 && findIndex(festivos, function(o){return new Date(o.date).toDateString() === inputDay.toDateString()}) == -1){
            return false;
        } else {
            return true;
        }
    }

    const verifyHour = (maxHour: number, currentDate: Date) => { // Verifica que no supere la hora máxima de pedido del día
        if((currentDate.getHours()*3600+(currentDate.getMinutes()*60)) < maxHour || maxHour === 0){
            return true;
        } else {
            return false;
        }
    }

    let currentDatetime:Date = new Date();
    let selectedDate:Date = new Date(inputData);

    // Calcular fecha mínima de entrega: +N días calendario, luego buscar siguiente hábil
    // Lun-Jue antes de maxHour: +beforeLimitTime días calendario
    // Lun-Jue después de maxHour (y hoy es laborable): +beforeLimitTime+1 días calendario
    // Viernes: +2 días extra para saltar el fin de semana
    let daysToAdd = beforeLimitTime;
    if(!isFestivo(currentDatetime) && !verifyHour(maxHour, currentDatetime)){
        daysToAdd = beforeLimitTime + 1;
    }
    if(!isFestivo(currentDatetime) && currentDatetime.getDay() === 5){
        daysToAdd += 2;
    }

    let minDate:Date = new Date();
    minDate.setHours(0,0,0,0);
    minDate.setDate(minDate.getDate() + daysToAdd);
    while(isFestivo(minDate)){
        minDate.setDate(minDate.getDate() + 1);
    }

    // Usar la fecha más tardía entre la seleccionada y la mínima
    if(selectedDate.getTime() < minDate.getTime()){
        selectedDate = minDate;
    }

    // Asegurar que la fecha seleccionada sea hábil
    while(isFestivo(selectedDate)){
        selectedDate.setDate(selectedDate.getDate() + 1);
    }

    let wasChanged = new Date(inputData).toDateString() !== selectedDate.toDateString();

    return [selectedDate, wasChanged];
}

const createArrayPedido = (farm:IFarm, cart: Array<IProduct> ,cartDate: any, 
    cartComments: string|undefined,
    idPedido:number|undefined, estado: number, moveType: number) => {
    let currentPedido : IPedido =  {
    business: farm.business,
    id: idPedido,
    farmId: farm.id,
    date: GetFormattedDate(cartDate), 
    comments: cartComments!==undefined?cartComments:'', 
    status: estado, 
    products:cart,
    farm: farm,
    numberLines: cart.length,
    moveType: moveType
    }

return currentPedido
}

const calculateQuantityItems = (inputCartProducts : Array<IProduct>) => {
    return find(inputCartProducts, function(o) {return o.quantity==undefined||o.quantity==0})
}

const GetFormattedPedidoDate = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime .getFullYear();
    return (day < 10?'0'+day:day) + "/" + (month < 10?'0'+month:month) + "/" + year;
}

const GetDatetimeFormat = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime.getFullYear();
    var hour = todayTime.getHours();
    var minut = todayTime.getMinutes();

    return (day < 10?'0'+day:day) + "/" + (month < 10?'0'+month:month) + "/" + year + " " + (hour < 10?'0'+hour:hour)+ ":" + (minut < 10?'0'+minut:minut)+"h";
}

function addZeroesDecimals(num:number, decimals:number) {
    let roundDecimals:string = num.toFixed(decimals);
    roundDecimals = roundDecimals.replace('.',',');
    return roundDecimals;
}

function addThousandSeparator(num:string|number, comma:boolean) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `${comma?',':'.'}`);
}

const allowAddItem=(product:IProduct, farm:IFarm, currentFeedStageIndex:number, feedPlan: IFeedPlan)=>{
    let result = undefined; // Por defecto permite pedirlo

    if(!feedPlan.continues && currentFeedStageIndex !== 99){ // Realiza el control en caso de no ser una granja de Ciclo contínuo y permite siempre coger los productos de la etapa 99

        // Primero verifica si se ha sobrepasado la desviación máxima permitida
        const stage = feedPlan.plan[currentFeedStageIndex];
        const hasFeed = stage !== undefined && Array.isArray(stage.feed) && stage.feed.length > 0;
        if(hasFeed){
            let qtyReserved = stage.feed[0].qtyReserved;
            let qtyReal = stage.feed[0].qtyReal;
            let qtyRegularization = stage.feed[0].qtyRegularization || 0;
            let qtyPrevista = stage.feed[0].qtyEstimated;
            let qtyPercentage = ((qtyReal + qtyReserved - qtyRegularization)/qtyPrevista)*100;

            let upDesv = stage.feed[0].upperAllowedDeviation + 100;

            if(qtyPercentage >= upDesv){
                result = `LÍMITE ALCANZADO`;
            }
        }

    }
    
    if(product.medicated == 1){ // Se comprueba que si el producto es medicado, el usuario pueda pedirlo para esa granja
        if(farm.allowMedicado == 0){
            result = `NO AUTORIZADO`;
        }
    }

    return result;
}

const getProductsCurrentFeedPlanStage=(products:Array<IProduct>, farm:IFarm)=>{
    let newProducts:Array<IProduct> = [];

    farm.feedPlan.map((feedPlan:IFeedPlan, idx00:number)=>{
        let currentFeedStageIndex = getCurrentFeedPlanStage(feedPlan);
        let etapa99Index = findIndex(feedPlan.plan, function(o){return o.feedStage == 99});
    
    let qtyPrevista:any = undefined;
    let qtyReal:any = undefined;
    let qtyReserved:any = undefined;
    let qtyRegularization:any = undefined;
    let downDesv:any = undefined;
    let qtyConsumidaPercentage:any = undefined;
    let tmpStageData:IFeed|undefined = undefined;

    if(currentFeedStageIndex !== -1 && feedPlan.plan[currentFeedStageIndex] !== undefined && Array.isArray(feedPlan.plan[currentFeedStageIndex].feed) && feedPlan.plan[currentFeedStageIndex].feed.length > 0){
        qtyPrevista = feedPlan.plan[currentFeedStageIndex].feed[0].qtyEstimated;
        qtyReal = feedPlan.plan[currentFeedStageIndex].feed[0].qtyReal;
        qtyReserved = feedPlan.plan[currentFeedStageIndex].feed[0].qtyReserved;
        qtyRegularization = feedPlan.plan[currentFeedStageIndex].feed[0].qtyRegularization || 0;
        qtyConsumidaPercentage = ((qtyReal + qtyReserved - qtyRegularization)/qtyPrevista)*100;
        downDesv = 100 - feedPlan.plan[currentFeedStageIndex].feed[0].lowerAllowedDeviation;
    } else if(currentFeedStageIndex !== -1) {
        // Stage exists but has no feed articles (Dynamics can have empty stages)
        // Treat as 0% consumption with 0% deviation so products from adjacent stages can still appear
        qtyConsumidaPercentage = 0;
        downDesv = 0;
    }
    
    
        products.map((item:IProduct, index:number)=>{
            if(item.business == farm.business){
                if(downDesv !== undefined && qtyConsumidaPercentage !== undefined) {
                // Revisa los productos para el feedPlan actual
                if(feedPlan.plan[currentFeedStageIndex] !== undefined && Array.isArray(feedPlan.plan[currentFeedStageIndex].feed) && findIndex(feedPlan.plan[currentFeedStageIndex].feed, function(o) { return o.itemId == item.itemId; }) !== -1){

                    tmpStageData = feedPlan.plan[currentFeedStageIndex].feed[0];
                    const tmpQtyRegularization = tmpStageData.qtyRegularization || 0;
                    const remainingQty = (tmpStageData.qtyEstimated - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization));
                    newProducts.push({
                        ...item,
                        allowItem:allowAddItem(item, farm, currentFeedStageIndex, feedPlan),
                        maxQty:((tmpStageData.qtyEstimated + (tmpStageData.qtyEstimated * (tmpStageData.upperAllowedDeviation/100))) - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization)),
                        continues: feedPlan.continues,
                        feedStage: currentFeedStageIndex,
                        numEtapa: feedPlan.plan[currentFeedStageIndex].feedStage,
                        batchId: feedPlan.plan[currentFeedStageIndex].feed[findIndex(feedPlan.plan[currentFeedStageIndex].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                        remainingQty: remainingQty
                    });
                }
    
                // Si qtyConsumidaPercentage es igual o superior a downDesv abre la siguiente etapa
                if(feedPlan.plan[currentFeedStageIndex] !== undefined && qtyConsumidaPercentage >= downDesv && currentFeedStageIndex < (feedPlan.plan.length-1) && Array.isArray(feedPlan.plan[currentFeedStageIndex+1].feed) && findIndex(feedPlan.plan[currentFeedStageIndex+1].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                    tmpStageData = feedPlan.plan[currentFeedStageIndex+1].feed[0];
                    const tmpQtyRegularization = tmpStageData.qtyRegularization || 0;
                    const remainingQty = (tmpStageData.qtyEstimated - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization));
                    newProducts.push({
                        ...item,
                        allowItem:allowAddItem(item, farm, currentFeedStageIndex+1, feedPlan),
                        maxQty:((tmpStageData.qtyEstimated + (tmpStageData.qtyEstimated * (tmpStageData.upperAllowedDeviation/100))) - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization)),
                        continues: feedPlan.continues,
                        feedStage: (currentFeedStageIndex + 1),
                        numEtapa: feedPlan.plan[currentFeedStageIndex + 1].feedStage,
                        batchId: feedPlan.plan[currentFeedStageIndex+1].feed[findIndex(feedPlan.plan[currentFeedStageIndex + 1].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                        remainingQty: remainingQty
                    });
                }

                // Etapa anterior: se abre si tiene cantidad restante y no ha superado su propio upperAllowedDeviation
                if(feedPlan.plan[currentFeedStageIndex] !== undefined && currentFeedStageIndex > 0 && Array.isArray(feedPlan.plan[currentFeedStageIndex-1].feed) && findIndex(feedPlan.plan[currentFeedStageIndex-1].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                    tmpStageData = feedPlan.plan[currentFeedStageIndex-1].feed[0];
                    const tmpQtyRegularization = tmpStageData.qtyRegularization || 0;
                    const remainingQty = (tmpStageData.qtyEstimated - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization));
                    const prevConsumption = ((tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization) / tmpStageData.qtyEstimated) * 100;
                    const prevUpperLimit = tmpStageData.upperAllowedDeviation + 100;

                    if(prevConsumption < prevUpperLimit){
                        newProducts.push({
                            ...item,
                            allowItem:allowAddItem(item, farm, currentFeedStageIndex-1, feedPlan),
                            maxQty:((tmpStageData.qtyEstimated + (tmpStageData.qtyEstimated * (tmpStageData.upperAllowedDeviation/100))) - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization)),
                            continues: feedPlan.continues,
                            feedStage: (currentFeedStageIndex - 1),
                            numEtapa: feedPlan.plan[currentFeedStageIndex - 1].feedStage,
                            batchId: feedPlan.plan[currentFeedStageIndex-1].feed[findIndex(feedPlan.plan[currentFeedStageIndex - 1].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                            remainingQty: remainingQty
                        });
                    }
                }
    
                    // En caso de haber etapa 99 añade el producto
                    if(etapa99Index !== -1 && Array.isArray(feedPlan.plan[etapa99Index].feed) && findIndex(feedPlan.plan[etapa99Index].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                        newProducts.push({
                            ...item,
                            allowItem:allowAddItem(item, farm, etapa99Index, feedPlan),
                            maxQty:farm.truckLoad,
                            continues: feedPlan.continues,
                            feedStage: (etapa99Index),
                            numEtapa: feedPlan.plan[etapa99Index].feedStage,
                            batchId: feedPlan.plan[etapa99Index].feed[findIndex(feedPlan.plan[etapa99Index].feed, function(o) { return o.itemId == item.itemId; })].batchId
                        });
                    }
                }
            }
        })
    })

    return sortBy(newProducts, [function(o) { return o.numEtapa; }]);
}

const getCurrentFeedPlanStage=(feedplan:IFeedPlan)=>{
    let currentFeedStageIndex = -1;

    if(feedplan.plan.length === 0){
        return -1;
    }

    let firstNonEmptyIndex = -1;

    for (var i = 0; i < feedplan.plan.length; i++) { // Mira la última etapa donde tiene pienso consumido
        const stage = feedplan.plan[i];
        const hasFeed = Array.isArray(stage.feed) && stage.feed.length > 0;
        if(hasFeed && firstNonEmptyIndex === -1){
            firstNonEmptyIndex = i;
        }
        if(hasFeed){
            if((stage.feed[0].qtyReal + stage.feed[0].qtyReserved) > 0 && stage.feedStage != 99){ // Omite la etapa 99 para que no se posicione nunca allí
                currentFeedStageIndex = i;
            }
        }
    }

    if(currentFeedStageIndex === -1){
        currentFeedStageIndex = firstNonEmptyIndex; // Puede quedar en -1 si todas las etapas están vacías
    }

    return currentFeedStageIndex;
}

const verifyCarga = (box:number, quantity:number, truckLoad:number, forceDown?:boolean) =>{
    let quantityBox:number = Math.floor(truckLoad/box)
    let numberBox : number = forceDown?Math.floor(quantity/quantityBox):Math.round(quantity/quantityBox);
    let resultQuantity = quantity;
    if(numberBox==0){
        numberBox=1;
    }

    if(resultQuantity == ((box-numberBox)==0?truckLoad:(numberBox*quantityBox)) && resultQuantity <=truckLoad) {
        return [true, resultQuantity];
    }
    let modifiedQuantity = numberBox*quantityBox;

    if(modifiedQuantity <= truckLoad){
        return [false, ((box-numberBox)==0?truckLoad:(numberBox*quantityBox))];
    }

    return [false, truckLoad];
}

const allowAddQtySilo=(silo:ISilo, qty:number)=>{
    if(qty > silo.capacity){
        return false;
    }
    return true;
}

const currentLoad=(products:Array<IProduct>)=>{
    let totalQty = reduce(products, function(sum, n) {
        return sum + (n.quantity==undefined?0:n.quantity);
    }, 0);
    return totalQty;
}

const allowViewSilo=(silo:ISilo, product:IProduct, type:number)=>{
    switch(type){
        case 1: { // Verifica si el producto está dentro de los artículos permitidos para el silo
            const siloType:string = (silo as any).typeFeedSiloId ?? (silo as any).tipoPiensoSiloID ?? '';
            // Si no se ha configurado el tipo de pienso en el silo, permite asignar el producto en este
            if(!siloType || siloType.length === 0){
                return true;
            }

            const productGroups = Array.isArray(product.groupTypeSiloId) ? product.groupTypeSiloId : [];
            // Si el producto no trae grupos (p.ej. orígenes SQL), no restringimos por tipo de silo
            if(productGroups.length === 0){
                return true;
            }
            const findGroup = findIndex(productGroups, function(o){return o.typeFeedSiloId == siloType});

            if(findGroup > -1){
                return true;
            }
            return false;
        }
        default: // Por defecto no permite ver el silo
            return false;
    }
}

const getTotalQtyStage = (cart:Array<IProduct>, product:IProduct) => {
    let totalQty = reduce(cart, function(sum, n) {
        if(n.feedStage == product.feedStage){
            if(n.itemId !== product.itemId){
                return sum + (n.quantity==undefined?0:n.quantity);
            }
        }
        return sum;
    }, 0);
    return totalQty;
}

const controlProduct=(product:IProduct, cart:Array<IProduct>, farm:IFarm, quantity:number)=>{
    let qty:number = quantity;
    let result = 0;
    let count = 0;
    let maxLoop = 2;
    let doAgain = false;
    do{
        doAgain = false;

        if(!product.continues){ // Realiza el control en caso de no ser una granja del tipo Ciclo contínuo
            let accumStage = getTotalQtyStage(cart, product);

            if((accumStage + qty) > product.maxQty){ // Si la cantidad de producto supera la cantidad total de la etapa, devuelve el error y la cantidad siempre y cuando no sean granjas de madres
                result = 3;
                qty = product.maxQty-accumStage;
            }
        }

        let load = currentLoad(cart) - (product.isInCart && product.quantity?product.quantity:0);

        let freeSpace = farm.truckLoad - load;

        if((freeSpace - qty) < 0){ // Si la carga del camión es superada, devuelve el error y la carga que debería tener
            result = 2;
            qty = freeSpace;
        }
    
        if(product.notRoundBox == 0){ // Se redondea el cajón
            let carga:any = verifyCarga(6, qty, farm.truckLoad, count==0?false:true);
            
            if(!carga[0]){ // Ajusta cantidad cajón
                qty = carga[1];
                doAgain = true;
                if(result == 0){ // Solo dice que ha ajustado cajón cuando no ha habido otro ajuste
                    result = 1;
                }
            }
        }
        count++;
    }   while(doAgain && count <=maxLoop)

    if(doAgain){
        result = -1;
        qty = 0;
    }
    return [result, qty];
}

const controlSiloProduct=(silo:ISilo, product:IProduct, quantity:number)=>{
    let qty:number = quantity;
    let result:number = 0;
    if(!allowAddQtySilo(silo, qty)){ // Controla si la cantidad excede la capacidad del silo
        result = 1;
        qty = silo.capacity;
    }

    return([result, qty]);
    
}

const CheckNumberPlate=(type: number, numberplate:string)=>{
    switch(type){
        case 1: // Matrícula de camión
        return /^[0-9]{4}[aA-zZ]{3}/.test(numberplate);
        case 2: // Matrícula de remolque
            return /^[aA-zZ]{1}[0-9]{4}[aA-zZ]{3}/.test(numberplate);
        default:
            return false;
    }
}

const isDynamicsFarm = (business?: string): boolean => {
    if (!business) return false;
    return ['pdx', 'tor'].includes(business.toLowerCase());
};

export { fetchAPI, searchFarms, GetFormattedDate,
    GetDate, searchProducts,
    getNextOrden, getQuantitySilo, getAcumuladoPienso,
    verifyDateTimeLimit, createArrayPedido,
    calculateQuantityItems, GetFormattedPedidoDate, addZeroesDecimals,
    /*getStatusDescriptionColor,*/searchPedidos, getProductsCurrentFeedPlanStage,
    getCurrentFeedPlanStage, verifyCarga, GetDatetimeFormat,
    addThousandSeparator, allowAddQtySilo, currentLoad, allowViewSilo,
    getTotalQtyStage, controlProduct, controlSiloProduct, CheckNumberPlate,
    isDynamicsFarm
};